export const roles = {
    ROLE_ADMIN: 'ADMIN',
    ROLE_AUTOPSY: 'ΑΥΤΟΨΙΕΣ',
    ROLE_BLOWER: 'ΕΜΦΥΣΗΣΕΙΣ',
    ROLE_CONSTRUCTOR_A: 'ΚΑΤΑΣΚΕΥΑΣΤΗΣ Α',
    ROLE_CONSTRUCTOR_B: 'ΚΑΤΑΣΚΕΥΑΣΤΗΣ Β',
    ROLE_COORDINATOR: 'ΣΥΝΤΟΝΙΣΤΗΣ (ΓΡΑΦΕΙΟ)',
    ROLE_EARTH_WORKER: 'ΧΩΜΑΤΟΥΡΓΙΚΑ',
    ROLE_WELDER: 'ΚΟΛΛΗΣΕΙΣ / ΜΕΤΡΗΣΕΙΣ',
    ROLE_CONTRACTOR: 'ΕΡΓΟΛΑΒΟΣ'
}
export default {
    data() {
        return {
            roles
        }
    },
    methods: {
        getRoleColor(role) {
            switch (role) {
            case 'ROLE_ADMIN': return '#5f9595'
            case 'ROLE_CONTRACTOR': return '#5f9595'
            case 'ROLE_BLOWER': return '#c59dc2'
            case 'ROLE_COORDINATOR': return '#7393B3'
            case 'ROLE_AUTOPSY': return '#f0bc68'
            case 'ROLE_EARTH_WORKER': return '#723d46'
            case 'ROLE_CONSTRUCTOR_A': return '#c4d7d1'
            case 'ROLE_CONSTRUCTOR_B': return '#c4d7d1'
            case 'ROLE_WELDER': return '#aab8bb'
            }
        },
        getRoleText(role) {
            return role.split('ROLE_')[1]
        }
    }
}
